var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLab(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0403 19.25C18.4841 12.8662 15.5003 11.1837 15.5003 8V4.25H16.1253C16.2911 4.25 16.4501 4.18415 16.5673 4.06694C16.6845 3.94973 16.7503 3.79076 16.7503 3.625V2.375C16.7503 2.20924 16.6845 2.05027 16.5673 1.93306C16.4501 1.81585 16.2911 1.75 16.1253 1.75H9.87534C9.70958 1.75 9.55061 1.81585 9.4334 1.93306C9.31619 2.05027 9.25034 2.20924 9.25034 2.375V3.625C9.25034 3.79076 9.31619 3.94973 9.4334 4.06694C9.55061 4.18415 9.70958 4.25 9.87534 4.25H10.5003V8C10.5003 11.1837 7.51659 12.8662 4.96034 19.25C4.14659 21.2812 2.05659 24.25 13.0003 24.25C23.9441 24.25 21.8541 21.2812 21.0403 19.25V19.25ZM19.0191 21.4387C18.1416 21.7012 16.3953 22 13.0003 22C9.60534 22 7.85909 21.7012 6.98159 21.4387C6.67034 21.3462 6.54909 20.985 6.65909 20.6537C6.93409 19.8162 7.45284 18.3687 8.42284 16.7525C10.7928 12.8037 13.2516 17.3737 15.2978 17.3737C17.3441 17.3737 16.7828 15.4225 17.5778 16.7525C18.3094 17.9831 18.901 19.2916 19.3416 20.6537C19.4516 20.985 19.3303 21.345 19.0191 21.4387V21.4387Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLab);
export default __webpack_public_path__ + "static/media/icon-lab.720ebc56.svg";
export { ForwardRef as ReactComponent };